import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AssetDto } from '../../../../../../api/src/asset/models/asset.dto';
import { Type } from '../../../../../../api/src/asset/asset.entity';

export type VariationTrayMediaType = 'image' | 'video' | 'auto';

@Component({
	selector: 'app-image-editor-variation-tray',
	templateUrl: './image-editor-variation-tray.component.html',
	styleUrls: ['./image-editor-variation-tray.component.scss']
})
export class ImageEditorVariationTrayComponent implements OnInit {
	@Input() public assets: Partial<AssetDto>[];
	@Input() public mediaType: VariationTrayMediaType = 'auto';
	@Input() public selectedAssetId: string | null = null;
	@Output() setActiveAsset: EventEmitter<AssetDto> = new EventEmitter<AssetDto>();

	constructor() { }

	ngOnInit(): void {
	}

	/**
	 * Determine if an asset should be displayed as video
	 */
	isVideo(asset: Partial<AssetDto>): boolean {
		if (this.mediaType === 'video') {
			return true;
		}
		if (this.mediaType === 'image') {
			return false;
		}
		// Auto-detect based on asset type or mime type
		return asset.type === Type.Video ||
			asset.mimeType?.startsWith('video/') ||
			asset.assetPath?.match(/\.(mp4|webm|mov|avi)$/i) !== null;
	}

	/**
	 * Get the thumbnail URL for a video asset
	 */
	getVideoThumbnail(asset: Partial<AssetDto>): string | null {
		return asset.metadata?.thumbnailUrl || null;
	}

}
